// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Components
import DashboardDisplayPathModifiers from '../layout/dashboard-display-path-modifiers';
import LockedIndicator from './locked-indicator';
import Permissions from '../core/permissions';
import RecordLocker from './record-locker';
import SelectNetworkForm from './select-network-form';

// Styles
import './select-network-for-display-path-modifiers.scss';

// Containers
import withForm from '../../containers/with-form';

const formName = 'selectNetworkForDisplayPathModifiers';

function SelectNetworkForDisplayPathModifiers({formData, lockedRecords, locallyLocked}) {
    const getFormProps = () => ({
        className: 'select-network-for-display-path-modifiers',
        formName,
    });

    const selectedNetworkName = get(formData, 'values.network.name');

    const locallyLockedNetwork = get(locallyLocked, formName, []);

    const lockedNetworkByOtherUsersForDisplayPathModifier = get(lockedRecords, formName, [])
        .filter((lockedRecord) => !locallyLockedNetwork.includes(lockedRecord.recordId))
        .map((lockedRecord) => lockedRecord.recordId);

    const isNetworkSelected = () => !!selectedNetworkName;

    const isNetworkLockedByAnotherUser = () =>
        lockedNetworkByOtherUsersForDisplayPathModifier &&
        lockedNetworkByOtherUsersForDisplayPathModifier.includes(selectedNetworkName);

    return (
        <>
            {isNetworkSelected() ? (
                <div className="select-network-for-display-path-modifiers--lock">
                    <Permissions
                        allowRoles={['networkDisplayPathModifier_update', 'networkDisplayPathModifier_delete']}
                        notAuthorizedMessage={false}
                    >
                        <RecordLocker recordId={selectedNetworkName} serviceKey={formName} />
                    </Permissions>
                    <LockedIndicator
                        detail={true}
                        lockId={selectedNetworkName}
                        recordLabel="Network"
                        serviceKey={formName}
                    />
                </div>
            ) : null}

            <SelectNetworkForm {...getFormProps()} />
            {isNetworkSelected() && !isNetworkLockedByAnotherUser() ? (
                <>
                    <hr className="select-network-for-display-path-modifiers--line" />
                    <div className="select-network-for-display-path-modifiers--wrapper">
                        <DashboardDisplayPathModifiers />
                    </div>
                </>
            ) : null}
        </>
    );
}

SelectNetworkForDisplayPathModifiers.propTypes = {
    className: PropTypes.string,
    formData: PropTypes.object,
    formName: PropTypes.string.isRequired,
    locallyLocked: PropTypes.object,
    lockedRecords: PropTypes.object,
};

export default withForm(SelectNetworkForDisplayPathModifiers, formName);
